import { PackageNameFieldBase } from '../../../shared/PackageNameFieldBase';

interface PackageNameFieldProps {
  value: string;
}

export function PackageNameField({ value }: PackageNameFieldProps) {
  return (
    <PackageNameFieldBase
      value={value}
      disabled
      inputClassName="border-neutral-700 border h-10 outline-none px-4 rounded-xl text-sm text-neutral-400 bg-neutral-800 cursor-not-allowed w-full placeholder:text-neutral-500"
    />
  );
}
